import http from 'plugins/axios'

export default {
  //更新后的查询所有用户信息
  getUserList(data) {
    return http.get({
      url: `/la/admin/send/coin/getList`,
      data
    })
  },
  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/rebateRate?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },
  getSendToken() {
    return http.get({
      url: `/la/admin/send/coin/getSendToken`,
    })
  },
  //赠币汇总
  getTotalInfo(data) {
    return http.get({
      url: `/la/admin/send/coin/getListTotal`,
      data,
    })
  },
}
